import { render } from "./Index.vue?vue&type=template&id=6557d3ab&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=6557d3ab&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=6557d3ab&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6557d3ab"]])

export default __exports__